export const SET_FILTER = 'SET_FILTER';
export const SET_DEFAULT_FILTERS = 'SET_DEFAULT_FILTERS';
export const SET_PAGINATION_ITEM = 'SET_PAGINATION_ITEM';
export const SET_FILTER_HAS_CHANGED = 'SET_FILTER_HAS_CHANGED';
export const SET_FILTERS_HAS_RESETED = 'SET_FILTERS_HAS_RESETED';
export const SET_TAB_ACTIVE_BY_PAGE = 'SET_TAB_ACTIVE_BY_PAGE';
